import '../App.css';
import './Header.css';
import {logout} from "../Utils/APIUtils";
import {useAuthenticationStatus} from "../Authentication/AuthenticationStatusProvider";
import {useTranslation} from "react-i18next";
import {useHeaderContext} from "./HeaderContextProvider";

const lngs = {
    en: {nativeName: 'English'},
    fr: {nativeName: 'Francais'}
};

const Header = ({onLogout}) => {
    const {t, i18n} = useTranslation();
    const {authenticationStatus} = useAuthenticationStatus();
    const {centeredHeaderContent} = useHeaderContext();

    return (
        <div className={'app-header'}>
            <a href={'/'}><img src={'/images/CEFI_logo2x.png'}/></a>

            <div className={'app-header--centered'}>
                {centeredHeaderContent}
            </div>

            <div className={'app-header--right'}>
                <div>
                    <span className={'clickable'} onClick={() => i18n.changeLanguage(i18n.resolvedLanguage === 'fr' ? 'en' : 'fr')}>
                        {i18n.resolvedLanguage === 'fr' ? 'English' : 'Français'}
                    </span>
                    <span>{authenticationStatus.user && authenticationStatus.user.username}</span>
                </div>
                <div>
                    {process.env.NODE_ENV === 'development' &&
                        <span
                            className={'environment-indicator'}>{process.env.REACT_APP_ENVIRONMENT_NAME || process.env.NODE_ENV} </span>
                    }
                    {authenticationStatus.isAuthenticated &&
                        <span className={'clickable'}
                              onClick={() => {
                                  logout().then(() => {
                                      onLogout();
                                  });
                              }}>
                            {t('Logout')}
                            <span className="material-symbols-outlined">
                                logout
                            </span>
                        </span>
                    }
                </div>
            </div>
        </div>
    )
}

export default Header;